<template>
  <nav id="topnav" class="defaultscroll is-sticky nav-sticky md:pl-28 flex flex-col items-center sm:block">
    <NavBarLogo />

    <div class="container">
      <NavBarUser @toggle-menu="handler" :isToggled="toggle" />

      <div id="navigation" :class="toggle === false ? 'none' : 'block'">
        <ul class="navigation-menu justify-center" :class="lightNav" >
          <li :class="activeMenu === '/' ? 'active' : ''">
            <router-link :to="{name:'LandingPageTalent'}" class="sub-menu-item">{{ $t('navi.talent') }}</router-link>
          </li>
          <li :class="activeMenu === '/job-search' ? 'active' : ''">
            <router-link :to="{name:'JobSearch'}" class="sub-menu-item">{{ $t('navi.jobs') }}</router-link>
          </li>
          <li :class="activeMenu === '/ai-search-agent' ? 'active' : '' ">
            <router-link :to="{name:'CandidateJobAlert'}" class="sub-menu-item">{{ $t('navi.jobAlert') }}</router-link>
          </li>
          <li :class="activeMenu === '/landing/employer' ? 'active' : ''">
            <router-link :to="{name:'LandingPageEmployer'}" class="sub-menu-item">{{ $t('navi.company') }}</router-link>
          </li>

          <li class="lg:hidden relative py-2 cursor-pointer">
            <div class="flex items-center space-x-4">
              <router-link
                  v-for="language in languages"
                  :key="language.code"
                  to=""
                  @click.prevent="changeLanguage(language.code)"
                  class="sub-menu-item flex items-center space-x-2 pl-4 pt-4"
              >
                <img
                    :src="language.flag"
                    :alt="language.label"
                    class="w-5 h-5 rounded-full"
                />
                <span class="text-sm text-gray-700 font-medium hover-color dark:text-white">{{ language.label }}</span>
              </router-link>
            </div>
          </li>

          <li class="hidden lg:flex relative" ref="dropdown">
            <router-link
                to=""
                @click.prevent="toggleLanguageDropdown"
                class="sub-menu-item pl-0 pr-0 pt-7 flex items-center"
            >
              <img
                  :src="currentLanguageFlag"
                  class="w-5 h-5 rounded-full mr-2"
                  alt="Current Language"
              />
            </router-link>
            <ul
                v-if="languageDropdownVisible"
                class="absolute top-full mt-2 dark:bg-slate-900 dark:border-none bg-white border border-gray-200 rounded shadow-md w-32 z-50"
            >
              <li
                  v-for="language in languages"
                  :key="language.code"
                  @click="changeLanguage(language.code)"
                  class="px-4 py-2 hover:bg-gray-100 cursor-pointer flex items-center space-x-2"
              >
                <img
                    :src="language.flag"
                    :alt="language.label"
                    class="w-5 h-5 rounded-full"
                />
                <span class="text-sm text-gray-700 font-medium dark:text-white">{{ language.label }}</span>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import vClickOutside from 'v-click-outside'
import feather from 'feather-icons'
import NavBarUser from '@/components/navbar/NavBarUser.vue'
import NavBarLogo from '@/components/navbar/NavBarLogo.vue'
import deFlag from '@/assets/images/flag/de.png'
import globeFlag from '@/assets/images/flag/globe.png'

export default {
  props: {
    lightNav: {
      type: String,
      required: true,
    },
    container: {
      type: String,
      required: true
    }
  },
  components: {
    NavBarUser, NavBarLogo
  },
  data () {
    return {
      toggle: false,
      activeMenu: '',
      loggedIn: false,
      languageDropdownVisible: false,
      currentLanguageFlag: deFlag,
      languages: [
        { code: 'en', label: 'English', flag: globeFlag },
        { code: 'de', label: 'Deutsch', flag: deFlag },
      ],
    }
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  watch: {
    $route(to) {
      this.activeMenu = to.path;
    },
  },
  created() {
    this.activeMenu = this.$route.path;
    const savedLanguage = localStorage.getItem('language') || 'de';
    this.setLanguage(savedLanguage);
  },
  mounted () {
    feather.replace()
    this.scrollToTop()
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    handler () {
      this.toggle = !this.toggle
    },
    scrollToTop () {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    toggleLanguageDropdown() {
      this.languageDropdownVisible = !this.languageDropdownVisible;
    },
    changeLanguage(code) {
      this.setLanguage(code);
      localStorage.setItem('language', code);
      this.languageDropdownVisible = false;
    },
    setLanguage(code) {
      const selectedLanguage = this.languages.find((lang) => lang.code === code);
      if (selectedLanguage) {
        this.currentLanguageFlag = selectedLanguage.flag;
        this.$i18n.locale = code;
      }
    },
    handleClickOutside(event) {
      const dropdownElement = this.$refs.dropdown;
      if (dropdownElement && !dropdownElement.contains(event.target)) {
        this.languageDropdownVisible = false
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
